import {ReactNode} from 'react';

import {MainMenu} from '~components/header/MainMenu';
import {MainTitleBar, MainTitleBarProps} from '~components/header/MainTitleBar';
import {Container, LayoutContent, LayoutHeader, LayoutNav} from './layoutComponents';

export interface BaseLayoutProps extends MainTitleBarProps {
  children?: ReactNode;
  customContentAndFooter?: boolean;
  /**
   * Fill the viewport, without the main menu — for pages opened as a fullscreen view over the app.
   * @default false
   */
  fullscreen?: boolean;
}

export function BaseLayout({
  children,
  customContentAndFooter = false,
  fullscreen = false,
  ...titleBarProps
}: BaseLayoutProps) {
  return (
    <Container>
      {!fullscreen && (
        <LayoutNav>
          <MainMenu />
        </LayoutNav>
      )}

      <LayoutHeader>
        <MainTitleBar titleOnly={fullscreen} {...titleBarProps} />
      </LayoutHeader>
      {customContentAndFooter ? (
        children
      ) : (
        // Fullscreen pages host an embedded app (Defect Studio, Measuring app) edge to edge: no side
        // padding around the iframe. The title bar above keeps its padding.
        <LayoutContent sx={fullscreen ? {paddingLeft: 0, paddingRight: 0} : undefined}>{children}</LayoutContent>
      )}
    </Container>
  );
}
